import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Scale, Archive } from 'lucide-react';

const datos = [
  {
    icon: AlertTriangle,
    dato: 'Hasta 7.500 €',
    titulo: 'de multa por no registrar la jornada',
    texto: 'La Inspección de Trabajo considera la falta de registro horario una infracción grave. Y la sanción es por cada centro de trabajo.',
  },
  {
    icon: Scale,
    dato: 'Desde 2019',
    titulo: 'es obligatorio para todas las empresas',
    texto: 'El Real Decreto-ley 8/2019 obliga a registrar diariamente la hora de entrada y salida de cada persona trabajadora. Sin excepciones por tamaño.',
  },
  {
    icon: Archive,
    dato: '4 años',
    titulo: 'debes conservar los registros',
    texto: 'Los fichajes deben estar a disposición de los empleados, sus representantes y la Inspección de Trabajo. Con Excel y papeles, es casi imposible demostrarlo.',
  },
];

export const PainSection = () => (
  <section className="bg-forest-900 noise-overlay py-20 sm:py-28" data-testid="pain-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-2xl mb-14">
        <p className="font-body-landing text-terracotta font-bold text-sm tracking-[0.15em] uppercase mb-4">¿Por qué lo necesitas?</p>
        <h2 className="font-display font-black text-bone text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
          El registro horario no es opcional. <span className="text-bone/50">Es ley.</span>
        </h2>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {datos.map((d, i) => (
          <motion.div
            key={d.dato}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.55, delay: i * 0.12 }}
            className="rounded-3xl border border-bone/10 bg-forest-800/60 p-8 hover:-translate-y-1 transition-transform duration-300"
            data-testid={`pain-card-${i}`}
          >
            <d.icon className="w-8 h-8 text-terracotta mb-6" />
            <p className="font-display font-black text-bone text-3xl mb-1">{d.dato}</p>
            <p className="font-body-landing font-bold text-bone/90 mb-4">{d.titulo}</p>
            <p className="font-body-landing text-sm text-bone/60 leading-relaxed">{d.texto}</p>
          </motion.div>
        ))}
      </div>
      <p className="font-body-landing text-bone/70 text-base md:text-lg mt-12 max-w-3xl">
        Y esto es solo el principio: la nueva normativa de 2026 endurecerá las sanciones y prohibirá el papel y el Excel.
        GestionaEmpleados registra cada fichaje con fecha, hora, origen y ubicación, lo guarda de forma segura
        y te genera el informe oficial en PDF o Excel en un clic. <span className="text-bone font-bold">Duerme tranquilo ante cualquier inspección.</span>
      </p>
    </div>
  </section>
);
